// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3Mkfg","content":"RecentSearches_content__k2uid"};